export const CHECKOUT = "checkout";

let counter = 1;

export const log = (...args: any[]): void => {
  // eslint-disable-next-line
  console.log(CHECKOUT, counter++, Date.now(), ...args);
};
export const warn = (...args: any[]): void => {
  // eslint-disable-next-line
  console.warn(CHECKOUT, counter++, Date.now(), ...args);
};
export const error = (...args: any[]): void => {
  // eslint-disable-next-line
  console.error(CHECKOUT, counter++, Date.now(), ...args);
};
